import {
  MozartMainDialog,
  MozartComplaintDialog,
  MozartTurnOffProduct,
  MozartDefectSolved,
} from './components';

import { useMozartDialogs } from './hooks';

import type { MozartComplaint } from 'features/mozart-notifications/domain';

export function MozartDialogs(props: Props) {
  const { onCloseMozartDialogs } = props;

  const {
    isLoading,
    novelties,
    complaints,
    complaint,
    openDialog,
    complaintDialogActions,
    onSelectComplaint,
    onBackFromComplaintDialog,
    onBackToComplaintDialog,
  } = useMozartDialogs();

  return (
    <>
      <MozartMainDialog
        open={true}
        isLoading={isLoading}
        novelties={novelties}
        complaints={complaints}
        onClose={onCloseMozartDialogs}
        onSelectComplaint={onSelectComplaint}
      />

      {openDialog.complain && (
        <MozartComplaintDialog
          hideBackdrop={true}
          open={openDialog.complain}
          actions={complaintDialogActions}
          complaint={complaint as MozartComplaint}
          onClose={onCloseMozartDialogs}
          onBack={onBackFromComplaintDialog}
        />
      )}

      {openDialog.turnOff && (
        <MozartTurnOffProduct
          hideBackdrop={true}
          open={openDialog.turnOff}
          complaint={complaint as MozartComplaint}
          onClose={onCloseMozartDialogs}
          onBack={onBackToComplaintDialog}
        />
      )}

      {(openDialog.solved || openDialog.turnOn) && (
        <MozartDefectSolved
          hideBackdrop={true}
          open={openDialog.solved || openDialog.turnOn}
          complaint={complaint as MozartComplaint}
          onClose={onCloseMozartDialogs}
          onBack={onBackToComplaintDialog}
        />
      )}
    </>
  );
}

interface Props {
  onCloseMozartDialogs: () => void;
}
